interface IconProps {
  color?: string;
  size?: string | number;
}

const RarityUncommonIcon = ({ color = "currentColor", size = 24 }: IconProps) => {
  return (
    <svg height={size} viewBox="0 0 24 24" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path d="M6 21C5.175 21 4.46875 20.7063 3.88125 20.1188C3.29375 19.5312 3 18.825 3 18V6C3 5.175 3.29375 4.46875 3.88125 3.88125C4.46875 3.29375 5.175 3 6 3H18C18.825 3 19.5312 3.29375 20.1188 3.88125C20.7063 4.46875 21 5.175 21 6V18C21 18.825 20.7063 19.5312 20.1188 20.1188C19.5312 20.7063 18.825 21 18 21H6Z" />
    </svg>
  );
};

export default RarityUncommonIcon;
